import useWrapper from "./useWrapper";

export default function usePermission(group, action) {
  const { permissions } = useWrapper();
  return !!permissions?.[group]?.[action];
}
